import { Post } from "services/apiService";
import { PROCESS_ORDERS_REQUEST, PROCESS_ORDERS_SUCCESS, PROCESS_ORDERS_ERROR } from "redux/actions/action-type";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";
import { encryptString } from "components/common/EncryptDecrypt";

export const processOrders = ({ orders, action }) => async (dispatch) => {

    let email = "";
    const sessionData = sessionStorage.getItem("persist:root");

    if (sessionData) {
        const parsedData = JSON.parse(sessionData);
        const userData = JSON.parse(parsedData.user);
        email = userData.loginResponse.email;
    }
    const encryptedEmailId = await encryptString(email);

    const apiUrl = `${BASE_URL}orders/@processorders?orderType=central-supplychain&action=${action}&apikey=${SOMS_API_KEY}`;

    const requestBody = { orders: orders, "userId": encryptedEmailId };
    dispatch({ type: PROCESS_ORDERS_REQUEST })

    Post({
        url: apiUrl,
        params: requestBody,
        config: {}
    }).then(response => {
        if (response.status === 200) {
            dispatch({
                type: PROCESS_ORDERS_SUCCESS,
                payload: response.data,
            });
        } else {
            dispatch({
                type: PROCESS_ORDERS_ERROR,
                payload: response.data.errorMessage || 'Error occurred while fetching orders.',
            });
        }
    })
        .catch(error => {
            dispatch({
                type: PROCESS_ORDERS_ERROR,
                payload: error.message || 'An error occurred while fetching data.',
            });
        })

}

export const amendOrdersForSiteCanteen = (payload, orderType, action) => async (dispatch) => {

    const apiUrl = `${BASE_URL}orders/@processorders?orderType=${orderType}&action=${action}&apikey=${SOMS_API_KEY}`;

    dispatch({ type: PROCESS_ORDERS_REQUEST })

    Post({
        url: apiUrl,
        params: payload,
        config: {}
    }).then(response => {
        if (response.status === 200) {
            dispatch({
                type: PROCESS_ORDERS_SUCCESS,
                payload: response.data,
            });
        } else {
            dispatch({
                type: PROCESS_ORDERS_ERROR,
                payload: response.data.errorMessage || 'Error occurred while fetching orders.',
            });
        }
    })
        .catch(error => {
            dispatch({
                type: PROCESS_ORDERS_ERROR,
                payload: error.message || 'An error occurred while fetching data.',
            });
        })

}
